<template>
  <section class="flex">
      <div class="container1">
           <h1>
         Meet our <br> Teachers
      </h1>
      <img  src="../../assets/underline.png" alt="">
      <h4>At Lil Yogis we strongly believe <br> that it’s never too early for yoga. <br> Making sure your kids come to <br> the mat early will lead to a more <br> holistic development. When you <br> sign them up, they’re not just </h4>
      <button>Learn more</button>
      </div>
      <div class="container2">
           <img  src="../../assets/teacher.png" alt="">
           <h4>Yogi Sabrina Merchants</h4>
           <h4 class="founder">Founder</h4>
      </div>
      <div class="container3">
          <div class="flex_teachers">
              <!-- <div class="container3 1">
          <div class="flex2">
              <div class="container1.1">
<img  src="../../assets/teacher1.png" alt="">
           <h4>Zen</h4>
           <h4 class="position">Lil Yogi</h4>
           </div>
<div class="container1.2">
           <img  src="../../assets/teacher2.png" alt="">
           <h4>Sam Kapoor</h4>
           <h4 class="position">Teacher</h4>
           </div>
           <div class="container1.3">
               <img  src="../../assets/teacher2.png" alt="">
           <h4>Sam Kapoor</h4>
           <h4 class="position">Teacher</h4>
           </div>
           </div>
           </div> -->
           <div class="container3 2">
           <div class="flex3">

               <div class="container2.1">
           <img  src="../../assets/teacher2.png" alt="">
           <h4>Nelofer</h4>
           <h4 class="position">Teacher</h4>
           </div>

           <div class="conatainer2.2">
           <img  src="../../assets/teacher3.png" alt="">
           <h4>Chandni</h4>
           <h4 class="position">Teacher</h4>
           </div>

           <div class="container2.3">
           <div class="circle" >
<h4 class="view">view all</h4>
           </div>
           </div>


           </div>
           </div>
           </div>
      </div>
  </section>
</template>

<script>
export default {

}
</script>

<style scoped>

.view{
    position: relative;
    /* left: 41px; */
        top: 60px;
        color: white;
        cursor: pointer;
}

.flex_teachers{
        display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    height: 497px;
    flex-wrap: wrap;
}

.position{
    color: #F0A202;
}

.founder{
    color: #791E94;
}

h1{
     font-size: 3rem;
    font-weight: 500;
    font-family: 'Original Surfer', cursive;
    color: #791E94;
}
h4{
    color: #445268;
    font-weight: 500;
    line-height: 200%;
}

.container1{
        display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-around;
    height: 450px;
    flex-wrap: wrap;
}

button{
     color: #445268;
    background-color: transparent;
    border: none;
    padding: 15px 60px;
    border-radius: 10px;
    cursor: pointer;
    border: 2px solid #791E94;
transition: 0.3s ease-in;
}
button:hover{
    background-color: #791E94;
    color: white;
}


.container2{
    text-align: center;
}
.flex3{
    display: flex;
    align-items: center;
     justify-content: space-between;
        width: 520px;
    text-align: center;
    flex-wrap: wrap;
}
.flex2{
    display: flex;
    align-items: center;
    justify-content: space-between;
        width: 520px;
    text-align: center;
    flex-wrap: wrap;
}
.flex{
    display: flex;
        width: 80%;
    margin: auto;
    justify-content: space-evenly;
    align-items: center;
    margin-top: 150px;
    flex-wrap: wrap;
}
.circle{
    background: #FF8100;
    border-radius: 50%;
    width: 150px;
    height: 150px;
        margin-bottom: 60px;
}


@media (max-width : 1273px){
    .flex3{
        width: 313px;
    }
    .container1{
        height: 506px;
    }
    .flex{
        height: 1662px;
    }
}

</style>